import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-order-of-orders-sale-preview',
  templateUrl: './order-of-orders-sale-preview.component.html',
  styleUrls: ['./order-of-orders-sale-preview.component.scss']
})
export class OrderOfOrdersSalePreviewComponent implements OnChanges {
  @Input() data: any = null;
  maxBlocks = 0;

  ngOnChanges() {
    if (this.data) {
      this.prepareTable(this.data);
    }
  }

  prepareTable(data: any[]) {
    this.maxBlocks = Math.max(
      ...data.map(p => p.warehouses.length)
    );
  }

  get blocks(): number[] {
    return Array.from({ length: this.maxBlocks });
  }
}
